import { useMemo } from "react";

export type GraphemePanelsMnemonicsTab = {
  name: string;
  pinyin: string | undefined;
  title: string;
};

/**
 * Raw mnemonics-tab state shared with the tab buttons. It intentionally holds
 * only values and the navigation primitives the press handlers build on — the
 * callbacks themselves live in the press hook so the context value never
 * carries a `useCallback` (han-no-context-callbacks). Audio playback is
 * deliberately NOT part of this surface: tab presses navigate; explicit
 * `PinyinSoundButton` presses play.
 */
export function useGraphemePanelsMnemonicsTabContextValue({
  activeIndex,
  morpheme,
  navigate,
  routeNames,
  tabButtonList,
}: {
  activeIndex: number;
  morpheme: string;
  navigate: (routeName: string) => void;
  routeNames: readonly string[];
  tabButtonList: readonly GraphemePanelsMnemonicsTab[];
}) {
  return useMemo(
    () => ({
      activeIndex,
      morpheme,
      navigate,
      routeNames,
      tabButtonList,
    }),
    [activeIndex, morpheme, navigate, routeNames, tabButtonList],
  );
}

export type GraphemePanelsMnemonicsTabContextValue = ReturnType<
  typeof useGraphemePanelsMnemonicsTabContextValue
>;
